import * as Radix from '@radix-ui/react-dropdown-menu';
import { Condition, EntitySearchType, formatTicker } from '@toggle/toggle';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useTagsSearch } from '~/hooks/use-tags-search/useTagsSearch';

import * as S from './ConditionAssetSearch.styles';

export interface ConditionAssetSearchProps {
  condition: Condition;
  response: (editedPayload: Partial<Condition>) => void;
}

export const ConditionAssetSearch = ({
  condition,
  response,
}: ConditionAssetSearchProps) => {
  const [filterValue, setFilterValue] = useState('');

  const isAssetNameMessage = (value: string) =>
    value.length < 16 && value.split(/\s+/).length < 3;

  const { tags: tagList, searchTags } = useTagsSearch({
    searchType: EntitySearchType.Entity,
    additionalConditionChecker: isAssetNameMessage,
  });

  const { t } = useTranslation('scenario');

  return (
    <S.DropdownMenuRoot data-testid="scenario-asset-search">
      <S.Trigger $active={false}>
        <S.TriggerLabel>{condition.formattedTicker}</S.TriggerLabel>
        <S.TriggerArrow />
      </S.Trigger>
      <Radix.Portal>
        <S.DropdownMenuContent align="start" sideOffset={5} side="bottom">
          <S.StyledFilter
            value={filterValue}
            placeholder={t('scenario:search')}
            onChange={e => {
              setFilterValue(e.target.value);
            }}
            onKeydown={() => {
              searchTags(filterValue);
            }}
          />
          <S.ScrollableList>
            {tagList.map(entity => {
              return (
                <S.Item
                  key={entity.tag}
                  onSelect={() => {
                    const ticker = formatTicker(entity);
                    const editedCondition = {
                      entity: entity.tag,
                      entityName: entity.name,
                      formattedTicker: ticker,
                      snake: '',
                      snakeName: '',
                    };
                    response(editedCondition);
                  }}
                >
                  {entity.name_short}
                </S.Item>
              );
            })}
          </S.ScrollableList>
        </S.DropdownMenuContent>
      </Radix.Portal>
    </S.DropdownMenuRoot>
  );
};
